// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .Resources_div__XOLsf {
    align-self: stretch;
    background-color: var(--Primary, #e7ecef);
  }
  @media (max-width: 991px) {
    .Resources_div__XOLsf {
      max-width: 100%;
    }
  }
  .Resources_sideBar__9scdO {
    gap: 20px;
    display: flex;
    min-height: 100%;
    justify-content: flex-start;
  }
  .Resources_div2__DLZHm {
    gap: 20px;
    display: flex;
  }
  @media (max-width: 991px) {
    .Resources_div2__DLZHm {
      flex-direction: column;
      align-items: stretch;
      gap: 0px;
    }
  }
  .Resources_column__3br4f {
    display: flex;
    flex-direction: column;
    line-height: normal;
    width: 20%;
    margin-left: 80px;
  }
  @media (max-width: 991px) {
    .Resources_column__3br4f {
      width: 100%;
    }
  }
  .Resources_div3__FXDF8 {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
  }
  @media (max-width: 991px) {
    .Resources_div3__FXDF8 {
      margin-top: 40px;
    }
  }

  .Resources_resButton__PPpQo{
    border: none;
  }

  .Resources_img__YYTiQ {
    aspect-ratio: 1.42;
    object-fit: contain;
    object-position: center;
    width: 100%;
    overflow: hidden;
    align-self: stretch;
  }
  .Resources_div4__65RDZ {
    color: #000;
    font-feature-settings: "clig" off, "liga" off;
    align-self: center;
    white-space: nowrap;
    font: 500 10px/220% Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  @media (max-width: 991px) {
    .Resources_div4__65RDZ {
      white-space: initial;
    }
  }
  .Resources_img2__AMM6e {
    aspect-ratio: 1.42;
    object-fit: contain;
    object-position: center;
    width: 100%;
    overflow: hidden;
    align-self: stretch;
    margin-top: 21px;
  }
  .Resources_div5__QXvEv {
    color: #000;
    font-feature-settings: "clig" off, "liga" off;
    font: 500 10px/220% Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  .Resources_column2__1aQmJ {
    display: flex;
    flex-direction: column;
    line-height: normal;
    width: 20%;
    margin-left: 20px;
  }
  @media (max-width: 991px) {
    .Resources_column2__1aQmJ {
      width: 100%;
    }
  }
  .Resources_div6__xM72R {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
  }
  @media (max-width: 991px) {
    .Resources_div6__xM72R {
      margin-top: 40px;
    }
  }
  .Resources_div7__l2VMV {
    color: #000;
    font-feature-settings: "clig" off, "liga" off;
    align-self: center;
    white-space: nowrap;
    font: 500 10px/220% Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  @media (max-width: 991px) {
    .Resources_div7__l2VMV {
      white-space: initial;
    }
  }

  .Resources_div8__dtUTc {
    color: #000;
    font-feature-settings: "clig" off, "liga" off;
    font: 500 10px/220% Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  /* .column3 {
    display: flex;
    flex-direction: column;
    line-height: normal;
    width: 20%;
    margin-left: 20px;
  }
  @media (max-width: 991px) {
    .column3 {
      width: 100%;
    }
  } */
  .Resources_div9__\\+zIJt {
    display: flex;
    margin-top: 4px;
    flex-grow: 1;
    flex-direction: column;
  }
  @media (max-width: 991px) {
    .Resources_div9__\\+zIJt {
      margin-top: 40px;
    }
  }
  .Resources_div10__0a3A1 {
    color: #000;
    font-feature-settings: "clig" off, "liga" off;
    align-self: center;
    margin-top: 6px;
    white-space: nowrap;
    font: 500 10px/220% Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  @media (max-width: 991px) {
    .Resources_div10__0a3A1 {
      white-space: initial;
    }
  }
  /* .img4 {
    aspect-ratio: 1.42;
    object-fit: contain;
    object-position: center;
    width: 100%;
    overflow: hidden;
    align-self: stretch;
    margin-top: 7px;
  } */
  .Resources_div11__ACHsT {
    color: #000;
    font-feature-settings: "clig" off, "liga" off;
    align-self: center;
    white-space: nowrap;
    font: 500 10px/220% Poppins, -apple-system, Roboto, Helvetica,
      sans-serif;
  }
  @media (max-width: 991px) {
    .Resources_div11__ACHsT {
      white-space: initial;
    }
  }

  .Resources_myLoanerContainer__fudEx {
    display: flex;
    flex-direction: column;
    width: 20px;
    border-radius: 16.842px;
    box-shadow:
      0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);
      background-color: var(--boxes, #F8F8FB);
    align-self: center;
    display: flex;
    width: 350px;
    height: 500px;
    max-width: 100%;
    text-align: center;
    margin-right: 10px;
    margin-top: 20px;
  }
  
  .Resources_myLoanerContent__ZDVYW {
    display: flex;
    margin-top: 10px;
    flex-direction: column;
    align-self: center;
    width: 230px;
    font-size: 24px;
    justify-content: center;
  }
`, "",{"version":3,"sources":["webpack://./src/components/Resources.module.css"],"names":[],"mappings":";EACE;IACE,mBAAmB;IACnB,yCAAyC;EAC3C;EACA;IACE;MACE,eAAe;IACjB;EACF;EACA;IACE,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,2BAA2B;EAC7B;EACA;IACE,SAAS;IACT,aAAa;EACf;EACA;IACE;MACE,sBAAsB;MACtB,oBAAoB;MACpB,QAAQ;IACV;EACF;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;EACnB;EACA;IACE;MACE,WAAW;IACb;EACF;EACA;IACE,aAAa;IACb,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,6CAA6C;IAC7C,kBAAkB;IAClB,mBAAmB;IACnB;gBACY;EACd;EACA;IACE;MACE,oBAAoB;IACtB;EACF;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,6CAA6C;IAC7C;gBACY;EACd;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;EACnB;EACA;IACE;MACE,WAAW;IACb;EACF;EACA;IACE,aAAa;IACb,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE,WAAW;IACX,6CAA6C;IAC7C,kBAAkB;IAClB,mBAAmB;IACnB;gBACY;EACd;EACA;IACE;MACE,oBAAoB;IACtB;EACF;;EAEA;IACE,WAAW;IACX,6CAA6C;IAC7C;gBACY;EACd;EACA;;;;;;;;;;;KAWG;EACH;IACE,aAAa;IACb,eAAe;IACf,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE,WAAW;IACX,6CAA6C;IAC7C,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB;gBACY;EACd;EACA;IACE;MACE,oBAAoB;IACtB;EACF;EACA;;;;;;;;KAQG;EACH;IACE,WAAW;IACX,6CAA6C;IAC7C,kBAAkB;IAClB,mBAAmB;IACnB;gBACY;EACd;EACA;IACE;MACE,oBAAoB;IACtB;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,uBAAuB;IACvB;kEAC8D;MAC5D,uCAAuC;IACzC,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,uBAAuB;EACzB","sourcesContent":["\n  .div {\n    align-self: stretch;\n    background-color: var(--Primary, #e7ecef);\n  }\n  @media (max-width: 991px) {\n    .div {\n      max-width: 100%;\n    }\n  }\n  .sideBar {\n    gap: 20px;\n    display: flex;\n    min-height: 100%;\n    justify-content: flex-start;\n  }\n  .div2 {\n    gap: 20px;\n    display: flex;\n  }\n  @media (max-width: 991px) {\n    .div2 {\n      flex-direction: column;\n      align-items: stretch;\n      gap: 0px;\n    }\n  }\n  .column {\n    display: flex;\n    flex-direction: column;\n    line-height: normal;\n    width: 20%;\n    margin-left: 80px;\n  }\n  @media (max-width: 991px) {\n    .column {\n      width: 100%;\n    }\n  }\n  .div3 {\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n  }\n  @media (max-width: 991px) {\n    .div3 {\n      margin-top: 40px;\n    }\n  }\n\n  .resButton{\n    border: none;\n  }\n\n  .img {\n    aspect-ratio: 1.42;\n    object-fit: contain;\n    object-position: center;\n    width: 100%;\n    overflow: hidden;\n    align-self: stretch;\n  }\n  .div4 {\n    color: #000;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    align-self: center;\n    white-space: nowrap;\n    font: 500 10px/220% Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div4 {\n      white-space: initial;\n    }\n  }\n  .img2 {\n    aspect-ratio: 1.42;\n    object-fit: contain;\n    object-position: center;\n    width: 100%;\n    overflow: hidden;\n    align-self: stretch;\n    margin-top: 21px;\n  }\n  .div5 {\n    color: #000;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    font: 500 10px/220% Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  .column2 {\n    display: flex;\n    flex-direction: column;\n    line-height: normal;\n    width: 20%;\n    margin-left: 20px;\n  }\n  @media (max-width: 991px) {\n    .column2 {\n      width: 100%;\n    }\n  }\n  .div6 {\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n  }\n  @media (max-width: 991px) {\n    .div6 {\n      margin-top: 40px;\n    }\n  }\n  .div7 {\n    color: #000;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    align-self: center;\n    white-space: nowrap;\n    font: 500 10px/220% Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div7 {\n      white-space: initial;\n    }\n  }\n\n  .div8 {\n    color: #000;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    font: 500 10px/220% Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  /* .column3 {\n    display: flex;\n    flex-direction: column;\n    line-height: normal;\n    width: 20%;\n    margin-left: 20px;\n  }\n  @media (max-width: 991px) {\n    .column3 {\n      width: 100%;\n    }\n  } */\n  .div9 {\n    display: flex;\n    margin-top: 4px;\n    flex-grow: 1;\n    flex-direction: column;\n  }\n  @media (max-width: 991px) {\n    .div9 {\n      margin-top: 40px;\n    }\n  }\n  .div10 {\n    color: #000;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    align-self: center;\n    margin-top: 6px;\n    white-space: nowrap;\n    font: 500 10px/220% Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div10 {\n      white-space: initial;\n    }\n  }\n  /* .img4 {\n    aspect-ratio: 1.42;\n    object-fit: contain;\n    object-position: center;\n    width: 100%;\n    overflow: hidden;\n    align-self: stretch;\n    margin-top: 7px;\n  } */\n  .div11 {\n    color: #000;\n    font-feature-settings: \"clig\" off, \"liga\" off;\n    align-self: center;\n    white-space: nowrap;\n    font: 500 10px/220% Poppins, -apple-system, Roboto, Helvetica,\n      sans-serif;\n  }\n  @media (max-width: 991px) {\n    .div11 {\n      white-space: initial;\n    }\n  }\n\n  .myLoanerContainer {\n    display: flex;\n    flex-direction: column;\n    width: 20px;\n    border-radius: 16.842px;\n    box-shadow:\n      0px 20.21094px 40.42188px -6.73698px rgba(39, 76, 119, 0.16);\n      background-color: var(--boxes, #F8F8FB);\n    align-self: center;\n    display: flex;\n    width: 350px;\n    height: 500px;\n    max-width: 100%;\n    text-align: center;\n    margin-right: 10px;\n    margin-top: 20px;\n  }\n  \n  .myLoanerContent {\n    display: flex;\n    margin-top: 10px;\n    flex-direction: column;\n    align-self: center;\n    width: 230px;\n    font-size: 24px;\n    justify-content: center;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"div": `Resources_div__XOLsf`,
	"sideBar": `Resources_sideBar__9scdO`,
	"div2": `Resources_div2__DLZHm`,
	"column": `Resources_column__3br4f`,
	"div3": `Resources_div3__FXDF8`,
	"resButton": `Resources_resButton__PPpQo`,
	"img": `Resources_img__YYTiQ`,
	"div4": `Resources_div4__65RDZ`,
	"img2": `Resources_img2__AMM6e`,
	"div5": `Resources_div5__QXvEv`,
	"column2": `Resources_column2__1aQmJ`,
	"div6": `Resources_div6__xM72R`,
	"div7": `Resources_div7__l2VMV`,
	"div8": `Resources_div8__dtUTc`,
	"div9": `Resources_div9__+zIJt`,
	"div10": `Resources_div10__0a3A1`,
	"div11": `Resources_div11__ACHsT`,
	"myLoanerContainer": `Resources_myLoanerContainer__fudEx`,
	"myLoanerContent": `Resources_myLoanerContent__ZDVYW`
};
export default ___CSS_LOADER_EXPORT___;
